import angular from 'angular';

export default angular
    .module('application.scene.identity.scene.email-verification.redirect', [])
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider, $transitionsProvider) {
    $stateProvider.state('identity.email-verification.redirect', {
        url: '?token'
    });

    $transitionsProvider.onStart({
        to: 'identity.email-verification.redirect'
    }, (transition) => {
        const $state = transition.injector().get('$state');
        const emailVerificationService = transition.injector().get('emailVerificationService');
        const navigationService = transition.injector().get('navigationService');
        const notificationService = transition.injector().get('notificationService');

        let params = transition.params() || {};

        if (params.token) {
            return emailVerificationService.verify(params.token).then(() => {
                showNotification('Congratulations!', 'Your email address has been verified.');
                return redirect();
            }, () => {
                showNotification('Verification Failed', 'We were unable to verify your email address. The link might be expired.');
                return redirect();
            });
        }

        return redirect();

        function showNotification(title, message) {
            navigationService.onSuccess(() => {
                notificationService.showError(message, title, true, 0);
            }, true);
        }

        function redirect() {
            return $state.target('identity.sign-in');
        }
    });
}



// WEBPACK FOOTER //
// ./src/application/scene/identity/scene/email-verification/scene/email-verification-redirect/index.js